import { Loading, MultiSelect } from '@shape-ds/components';
import { useGetCasesFilterOptionsQuery } from 'queries/cases/queries';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import './NotificationsAssetCategory.scss';

const NotificationsAssetCategory: React.FC = () => {
  const { t } = useTranslation();
  const { data: optionsData, isLoading } = useGetCasesFilterOptionsQuery();
  if (isLoading) {
    return <Loading center />;
  }
  return (
    <Controller
      name={'categories'}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => (
        <MultiSelect
          data={optionsData?.categories ?? []}
          initialValues={['ALL']}
          allValues={{ label: t('case:filters.allCategories'), value: 'ALL' }}
          onChangeCallback={onChange}
          className="notifications-asset-category"
        />
      )}
    />
  );
};

export default NotificationsAssetCategory;
